import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import AnimateHeight from 'react-animate-height';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { getDefaultImage, getThumbFile } from 'helpers/items';
import { getNameInCurrentLanguage } from 'helpers/intl';

import List from 'components/List';

import SimplePrompt from 'components/layout/SimplePrompt';
import Loader from 'components/layout/Loader';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import FormAutocomplete from 'components/forms/FormAutocomplete';

import may from 'js/security';

class CouponItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAdd: false,
      item: null,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      deleterStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState({ item: null });
      doNotify(1, messages.item_added);
    }

    if (!deleterStatus.pending && !deleterStatus.hasError && prevProps.deleterStatus.pending) {
      doNotify(1, messages.item_removed);
    }
  };

  showAdd = () => {
    this.setState({ showAdd: true });
  };

  setItem = (formName, item) => {
    this.setState({ item });
  };

  submitAdd = () => {
    const { entity, addItem } = this.props;
    const { item } = this.state;

    addItem(entity.getId(), item.id);
  };

  // dispatch remove action
  handleRemoveClick = (e, itemId) => {
    e.preventDefault();
    e.stopPropagation();

    const { entity, removeItem } = this.props;
    removeItem(entity.getId(), itemId);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      user,
      entity,
      formStatus,
    } = this.props;
    const { showAdd, item } = this.state;

    const columns = [messages.image, <i className="fa fa-eye" />, messages.item, messages.category];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const item = list.data.list[i];
      const { id, name, is_active: isActive, category } = item;

      const defaultImage = getDefaultImage(item);
      let defaultImageThumb;
      if (defaultImage !== undefined) {
        defaultImageThumb = getThumbFile(defaultImage);
      }

      tBody.push(
        <tr key={i}>
          <td class="v-align-middle">
            {defaultImageThumb !== undefined && (
              <img src={defaultImageThumb.web_link} style={{ width: '100px' }} alt={getNameInCurrentLanguage(name, appIntl)} />
            )}
          </td>
          <td class="v-align-middle">
            <i class={'fa fa-eye' + (isActive ? '' : '-slash')} />
          </td>
          <td class="v-align-middle">{getNameInCurrentLanguage(name, appIntl)}</td>
          <td class="v-align-middle">
            {!!category && (
              <>
                <IntlFormInlineSelector /> {getNameInCurrentLanguage(category.name, appIntl)}
              </>
            )}
          </td>
          <td className="v-align-middle text-right">
            {may('ROLE_ADMIN', user.roles) && (
              <SimplePrompt
                onSuccess={e => {
                  this.handleRemoveClick(e, id);
                }}
              />
            )}
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <>
        <AnimateHeight duration={500} height={showAdd ? 'auto' : 0}>
          <div className="padding-25 sm-padding-10">
            <Row>
              <Col xs={12} lg={6} lgOffset={3}>
                <div className="form-group-attached">
                  <FormAutocomplete
                    label={messages.add_item}
                    name="item"
                    onChange={this.setItem}
                    autocompleteType="item"
                    disabled={formStatus.pending}
                    returnValueObject
                  />
                </div>
                <div className="m-t-20 text-right">
                  <Button
                    bsStyle="primary"
                    type="submit"
                    bsSize="lg"
                    disabled={!item || formStatus.pending}
                    onClick={this.submitAdd}
                  >
                    <i class={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {messages.add}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </AnimateHeight>
        <List
          listName="items"
          url={`/api/coupondefinitions/${entity.getId()}/items.json`}
          // urlData={{ filters: { type: 'customer' } }}
          list={list}
          title={messages.items}
          iconClass="fa fa-cube"
          showNew
          newText={messages.add_item}
          newAction={this.showAdd}
          sortOptions={['name,asc', 'cdate,desc', 'mdate,desc']}
        >
          {resultTable}
        </List>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    list: state.list.items,
    formStatus: state.formStatus.addItem,
    deleterStatus: state.deleter.item,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    addItem: (couponId, itemId) => {
      formStatusDispatchHelper(
        'addItem',
        `/api/coupondefinitions/${couponId}/items/${itemId}.json`,
        {},
        'post',
        dispatch
      );
    },
    removeItem: (couponId, itemId) => {
      deleterDispatchHelper('item', `/api/coupondefinitions/${couponId}/items/${itemId}.json`, dispatch);
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CouponItems)
);
